import { render } from "./BE_Flaechen.vue?vue&type=template&id=265c4709&scoped=true&ts=true"
import script from "./BE_Flaechen.vue?vue&type=script&lang=ts"
export * from "./BE_Flaechen.vue?vue&type=script&lang=ts"

import "./BE_Flaechen.vue?vue&type=style&index=0&id=265c4709&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265c4709"]])

export default __exports__